import { render, staticRenderFns } from "./NormalSearchNav396.vue?vue&type=template&id=637f2bb4&scoped=true"
import script from "./NormalSearchNav396.vue?vue&type=script&lang=js"
export * from "./NormalSearchNav396.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "637f2bb4",
  null
  
)

export default component.exports